<div class="white-bg no-padding no-margin">
    <mat-card>
      <div style="text-align: center;">
        <span class="title-header" *ngIf="!ISEdit">Add Recommendation For Next Maintenance Event</span>
         <span class="title-header" *ngIf="ISEdit">Edit Recommendation For Next Maintenance Event</span>
      </div>
     
      <div *ngIf="equipmentDetails!=null" class="panel ng-star-inserted">
        <div class="topheaderbar">
          <div class="headerdiv">
            <span class="headerlabel">
              <b>{{'Date of Action' | translate | async}} </b> <span style="color: red;">*</span>
            </span>
            <mat-form-field class="action-input" style="max-width: 118px;">
              <input min="{{equipmentDetails?.EquipmentSetupDate | date:'yyyy-MM-dd'}}" matInput
                     [matDatepicker]="myDatepicker"
                     (ngModelChange)="pickedEventDate($event);ChecklastInspectionDateAndSMU()"
                     (click)="myDatepicker.open()" [(ngModel)]="Actiondate"
                     required autofocus>
              <mat-datepicker-toggle matSuffix [for]="myDatepicker"></mat-datepicker-toggle>
              <mat-datepicker #myDatepicker></mat-datepicker>
              <!-- [ngModel]="action.ActionDate"  -->
            </mat-form-field>
          </div>
          <div class="headerdiv">
            <span class="headerlabel">
              <b>{{'SMU/Hourmeter at Action Date ' | translate | async}} </b>
              <span style="color: red;">*</span>
            </span>
            <mat-form-field class="action-input" style="   max-width: 100px;">
              <input matInput type="number" [(ngModel)]="NewSMU" required
                      (focusout)="ChecklastInspectionDateAndSMU()">
            </mat-form-field>
          </div>
          <ng-container *ngIf="enableDistTravelledTracking">
            <div class="headerdiv">
              <span class="headerlabel">
                <b>{{'Distance Forward' | translate | async}} ({{userUOD}})</b> 
              </span>
              <mat-form-field class="action-input" style="   max-width: 130px;">
                <input matInput type="number" [(ngModel)]="distanceForward">
              </mat-form-field>
            </div>
  
            <div class="headerdiv">
              <span class="headerlabel">
                <b>{{'Distance Reverse' | translate | async}} ({{userUOD}})</b> 
              </span>
              <mat-form-field class="action-input" style="   max-width: 130px;">
                <input matInput type="number" [(ngModel)]="distanceReverse">
              </mat-form-field>
            </div>
            <div class="headerdiv">
              <span class="headerlabel">
                <b>{{'Total Distance' | translate | async}} ({{userUOD}})</b> 
              </span>
              <span class="totaldistance">{{distanceForward + distanceReverse}}</span>
            </div>
          </ng-container>
          <div *ngIf="equipmentDetails.FamilyId==203" class="headerdiv">
            <span class="headerlabel"><b>{{'Propel Hours' | translate | async}}</b></span>
            <mat-form-field class="action-input" style="   max-width: 95px;">
              <input matInput type="number" [(ngModel)]="NewPropel">
            </mat-form-field>
          </div>
          <div class="headerdiv">
            <span class="headerlabel"><b>Select Side</b> <span style="color: red;">*</span></span>
            <mat-form-field class="action-input" style="max-width: 100px;">
              <mat-select [(ngModel)]="selectedSide" (selectionChange)="ChangeSide()" required>
                <mat-option [value]="1">Left</mat-option>
                <mat-option [value]="2">Right</mat-option>
                <mat-option [value]="3">Both</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
  
          <div class="headerdiv" style="display: flex; justify-content: space-around;">
              <mat-label><b>{{'Severity' | translate | async}}</b></mat-label>
            <mat-form-field>
                <mat-select required id="recommendation" [(ngModel)]="severityId">
                  <mat-option [value]="r.Id" *ngFor="let r of SeverityDropDownList">{{r.Severitycategory}}</mat-option>
                </mat-select>
               
              </mat-form-field>

           
        
          </div>
          <div class="headerdiv" style="display: flex; justify-content: space-around;">
           <mat-form-field class="header-form-full-width">
              <mat-label ><b>Comment</b></mat-label>
              <textarea matInput placeholder="Comment" [(ngModel)]="Comment" rows="3"></textarea>
            </mat-form-field>
            </div>
        </div>

        
      </div>
  
      <div *ngIf="ShowWarning==true">
        <span *ngIf="ShowWarning==true" class="headerlabel" style="font-weight: bold;color: red;">{{warning}}</span>
      </div>
  
      <div class="center" *ngIf="equipmentSystems == null || IsLoading==true">
        <mat-spinner></mat-spinner>
      </div>
      
      <mat-card *ngIf="selectedSide>0 && NewSMU!=null" class="divcomponent">
        <div class="div-header" style="font-size: 20px;color: #1D2F36;font-weight: 100;">
          <span style="font-weight: 700;">Currently Installed Details</span>
          <span style="font-weight: 700;"> Actions Recommended</span>
          <span style="font-weight: 700;">Recommended Component Details</span>
        </div>
        <div class="panel panel--components" *ngFor="let system of equipmentSystems" style="padding: 1%;">
          <div style="display: flex; gap: 30px;">
            <div style="width: 30%; ">
              <span style="    font-size: 20px;color: #1D2F36;font-weight: 100;">
                {{system.Side}} Side -
                {{system.SystemType}} - {{system.SerialNumber}}
              </span>
            </div>
            <div>
              <mat-form-field class="input-action">
                <mat-select placeholder="Select Action" [(ngModel)]="system.ActionSelectionId" (selectionChange)="ChangeReplacementOptionType(system,system.Side)">
                  <mat-option [value]="1">No Action</mat-option>
                  <mat-option [value]="2">Replace</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field *ngIf="system.ActionSelectionId==2" class="input-serial">
                <mat-select placeholder="Select Action Type" [(ngModel)]="system.SysReplaceActionId"
                            (selectionChange)="ChangeReplacementOptionForSystem(system,system.Side)" required>
                  <mat-option *ngIf="system.SystemType=='Frame'" [value]="3">New Components</mat-option>
                  <mat-option *ngIf="system.SystemType=='Frame'" [value]="1">New Frame & Components</mat-option>
                  <mat-option *ngIf="system.SystemType=='Frame'" [value]="4">New Frame & Original Components</mat-option>
                  <mat-option *ngIf="system.SystemType=='Chain'" [value]="1">New</mat-option>
                  <mat-option [value]="2">Inventory</mat-option>
                </mat-select>
              </mat-form-field>

              <!-- <mat-form-field style="margin-left: 20px;" *ngIf="system.ActionSelectionId==2" class="input-serial">
                <mat-select placeholder="Select Status Of Removed Item" [(ngModel)]="system.RemoveStatusId"
                             required>
                  <mat-option  [value]="1">Off Machine</mat-option>
                  <mat-option  [value]="5">Scrap</mat-option>
                </mat-select>
              </mat-form-field> -->
            </div>
            <div *ngIf="(system.SysReplaceActionId==1 || system.SysReplaceActionId==4) && system.ActionSelectionId==2">
              <!-- <mat-form-field class="input-serial">
                <input matInput required placeholder="New Serial" [value]="system.NewSerialNo" (focusout)="ChangesSerial(system,$event)">
              </mat-form-field> -->
            </div>
            <div *ngIf="system.SysReplaceActionId==2  && system.ActionSelectionId==2">
              <mat-form-field *ngIf="system.Side=='Left' && system.SystemType=='Chain' && system.SysReplaceActionId==2  && system.ActionSelectionId==2">
                <mat-select (selectionChange)="selectedSystemReplacement($event,system.Side,system.SystemType,selectedReplacement)"
                            name="'Select Available Replacement'"
                            placeholder="{{Translate('Select Available Replacement')}}">
                  <mat-option *ngFor="let replacement of availableSystemReplacementsL" #selectedReplacement
                              [value]="replacement">
                    {{ replacement.SystemSerialNumber }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field *ngIf="system.Side=='Right'&& system.SystemType=='Chain' && system.SysReplaceActionId==2 && system.ActionSelectionId==2">
                <mat-select (selectionChange)="selectedSystemReplacement($event,system.Side,system.SystemType,selectedReplacement1)"
                            name="'Select Available Replacement'"
                            placeholder="{{Translate('Select Available Replacement')}}">
                  <mat-option *ngFor="let replacement of availableSystemReplacementsR" #selectedReplacement1
                              [value]="replacement">
                    {{ replacement.SystemSerialNumber }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field *ngIf="system.Side=='Left' && system.SystemType=='Frame' && system.SysReplaceActionId==2 && system.ActionSelectionId==2">
                <mat-select (selectionChange)="selectedSystemReplacement($event,system.Side,system.SystemType,selectedReplacement2)"
                            name="'Select Available Replacement'"
                            placeholder="{{Translate('Select Available Replacement')}}">
                  <mat-option *ngFor="let replacement of availableSystemReplacementsLFrame" #selectedReplacement2
                              [value]="replacement">
                    {{ replacement.SystemSerialNumber }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field *ngIf="system.Side=='Right' && system.SystemType=='Frame' && system.SysReplaceActionId==2 && system.ActionSelectionId==2">
                <mat-select (selectionChange)="selectedSystemReplacement($event,system.Side,system.SystemType,selectedReplacement3)"
                            name="'Select Available Replacement'"
                            placeholder="{{Translate('Select Available Replacement')}}">
                  <mat-option *ngFor="let replacement of availableSystemReplacementsRFrame" #selectedReplacement3
                              [value]="replacement">
                    {{ replacement.SystemSerialNumber }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div *ngIf="(system.SysReplaceActionId == 1 || system.SysReplaceActionId == 4) && system.SystemType=='Frame'">
              <mat-form-field class="input-budget">
                <input matInput placeholder="{{Translate('Budget Life')}}" name="FrameBudgetLife" [(ngModel)]="system.NewBudgetLife">
                <span matSuffix>{{Translate('Hrs')}}</span>
              </mat-form-field>
            </div>
            <div *ngIf="(system.SysReplaceActionId == 1 || system.SysReplaceActionId == 4) && system.SystemType=='Frame'">
              <mat-form-field class="input-budget">
                <input matInput placeholder="{{Translate('Budget Distance')}}" name="FrameBudgetDistance" [(ngModel)]="system.NewBudgetDistance">
                <span matSuffix>{{Translate('Km')}}</span>
              </mat-form-field>
            </div>
            <div *ngIf="(system.SysReplaceActionId == 1 || system.SysReplaceActionId == 4) && system.SystemType=='Frame'">
              <mat-form-field class="input-budget">
                <input matInput placeholder="{{Translate('Frame Cost')}}" name="FrameCost" [(ngModel)]="system.NewFrameCost">
              </mat-form-field>
            </div>
          </div>
          <div class="panel__content no-padding">
            <table class="table table--striped table--full-width">
              <thead>
                <tr>
                  <th></th>
                  <th>{{'Component' | translate | async}}</th>
                  <th style="padding: 0px 0px;">{{'Pos' | translate | async}}</th>
                  <th style="padding: 0px 12px;">{{'Brand' | translate | async}}</th>
                  <th class="right-align" style="padding: 0px 10px;">{{'CMU' | translate | async}}</th>
                  <th class="right-align" style="padding: 0px 10px;" *ngIf="enableDistTravelledTracking">{{'DOC' | translate | async}}</th>
                  <th style="padding: 0px 8px; border-right:solid 1px">{{'Worn (%)' | translate | async}}</th>
                  <th style="padding: 0px 2px;">{{'Action Selection' | translate | async}}</th>
                  <th style="padding: 0px;">{{'Action Type' | translate | async}}</th>
                   <th class="actionDetailsHeader">{{'Available Replacement' | translate | async}}</th>
                  <th class="actionDetailsHeader">{{'Brand' | translate | async}}</th> 
                  <!-- <th class="actionDetailsHeader"> </th> -->
                  <th class="actionDetailsHeader">{{'Worn %' | translate | async}}</th>
                  <th class="actionDetailsHeader" style="padding: 0px;">{{'Budget Life' | translate | async}}</th>
                  <th class="actionDetailsHeader" style="padding: 0px;" *ngIf="enableDistTravelledTracking">{{'Budget Distance' | translate | async}} ({{userUOD}})</th>
                    <th class="actionDetailsHeader" *ngIf="enableDistTravelledTracking" >{{'DOC' | translate | async}} ({{userUOD}})</th>
                  <th class="actionDetailsHeader" style="border-right:solid 1px">{{'CMU' | translate | async}}</th>
                 
                  <th class="actionDetailsHeader" style="padding: 5px;">Part Cost</th>
                  <th class="actionDetailsHeader" >Labour Cost</th>
                  <th class="actionDetailsHeader" >Misc Cost</th>
                  <th class="actionDetailsHeader">{{'Cost' | translate | async}}</th>
                  <th class="actionDetailsHeader">{{'Hour Gained' | translate | async}}</th>
                  <th class="actionDetailsHeader">{{'Comment' | translate | async}}</th>
                  <th class="actionDetailsHeader" *ngIf="ActiveWorkOrder==true">{{'WO #' | translate | async}}</th>
                <th class="actionDetailsHeader" ></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let component of system.Components" [ngClass]="{'ErrorAction': component.ActionSucess==2}">
  
                  <td class="component-cell">
                    <div class="component-photo-container">
                      <img [src]="component.Photo" alt="Component photo"
                           class="component-photo" />
                    </div>
                  </td>
  
                  <td>
                    <div title="{{component.Name}}" class="ComponentNameText">{{component.Name}}</div>
                  </td>
                  <td>
                    <div *ngIf="showPosition(component.Position, component.CompartTypeId)!=''">
                      {{showPosition(component.Position, component.CompartTypeId)}}
                    </div>

                    <div *ngIf="showPosition(component.Position, component.CompartTypeId)==''" >
                     <span style="opacity: 0;">Front test</span>
                    </div>
                  </td>
                  <td title="{{getTitle(component)}}">{{component.Brand}}</td>
  
                  <td class="right-align">{{component.Cmu}}</td>
                  <td class="right-align" *ngIf="enableDistTravelledTracking">{{component.DOC}}</td>
                  <td style="padding: 0px; border-right:solid 1px ">
                    <div style="display: flex; flex-direction: row;">
                      <span *ngIf="component.isLatest==true" class="Eval-{{ component.EvalCode}}">
                        <div *ngIf="component.PercentWorn != -9999" style="width:25px">
                          {{component.PercentWorn?.toFixed(0)}}%
                        </div>
                        <div *ngIf="component.PercentWorn == -9999" style="width:25px">{{'-'}}%</div>
                      </span>
                      <span *ngIf="component.isLatest==false" class="Eval-{{ component.EvalCode}}"
                            style="border-style: double;border-width: thick;" title="Result are not from latest inspection">
                        <div *ngIf="component.PercentWorn != -9999" style="width:25px">
                          {{component.PercentWorn?.toFixed(0)}}%
                        </div>
                        <div *ngIf="component.PercentWorn == -9999" style="width:25px">{{'-'}}%</div>
                      </span>
  
                    </div>
  
                  </td>
  
                  <td>
                    <mat-form-field style="max-width: 100px;">
                      <mat-select placeholder="Select Action" [(ngModel)]="component.ActionSelectionId"
                                  (selectionChange)="ChangeActionSelection(component, $event)">
                        <mat-option [value]="1">No Action</mat-option>
                        <mat-option [value]="2">Replace</mat-option>
                        <mat-option [value]="3">Repair</mat-option>
                        <!-- <mat-option [value]="4" *ngIf="system.SystemType=='Frame'">Keep Component</mat-option> -->
                      </mat-select>
                    </mat-form-field>
  
                  </td>
                  <td style="padding: 0px;">
                    <mat-form-field *ngIf="(component.CompartTypeId!=230  && component.CompartTypeId!=231) && system.SysReplaceActionId!=2 && system.SysReplaceActionId!=4 && component.ActionSelectionId != 1 && component.ActionSelectionId != 4">
                      <mat-select placeholder="Select Action Type" [(ngModel)]="component.SelectedActionTypeId"
                                  (selectionChange)="ChangeAvailableAction(component,system)" required>
                        <mat-option *ngFor="let action of component.AvailableActions" [value]="action.ActionTypeId" >
                          {{ action.ActionTypeName }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
  
                    <mat-form-field *ngIf="(component.CompartTypeId==230 || component.CompartTypeId==231) && (component.ActionSelectionId==3 || component.ActionSelectionId==2) && system.SysReplaceActionId!=2">
                      <mat-select placeholder="Select Action Type" [(ngModel)]="component.SelectedActionTypeId"
                                  (selectionChange)="ChangeAvailableAction(component,system)" required>
                        <mat-option *ngFor="let action of component.AvailableActions" [value]="action.ActionTypeId">
                          {{ action.ActionTypeName }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
  
                  </td>
                   <td class="actionDetailsHeader">

                  <div *ngIf=" (component.SelectedActionTypeId === 10602 || component.SelectedActionTypeId === 17 || component.SelectedActionTypeId === 10702) && system.SysReplaceActionId!=2 && component.ActionSelectionId == 3">
                    <mat-form-field *ngIf="component.allRollers?.length >= 1">
                      <mat-select name="Roller To Swap" [(ngModel)]="component.SwapComponentId" placeholder="{{'Select Swap component' | translate | async}}" disableOptionCentering panelClass="myPanelClass" required>
                        <mat-option *ngFor="let roller of component.allRollers"
                                    (click)="swapRollerEvent(roller,component,system)" [value]="roller.Id">
                          <span *ngIf="selectedSide==3">{{ roller.Side }} </span>{{ roller.Name }} {{ roller.Position }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <div style="margin-left: 25px; color: orange;" *ngIf="component.allRollers?.length == 0 || component.allRollers === null || component.allRollers === undefined">
                      {{ 'Note : There are not enough same type of rollers to swap position with on this system' | translate | async }}
                    </div>
                  </div>
                  <div *ngIf="component.ChainSysReplaceAction==2 && system.SysReplaceActionId!=2">
                    <mat-form-field *ngIf="system.Side=='Left'">
                      <mat-select (selectionChange)="selectedSystemReplacement($event,system.Side,null,null)"
                                  [(ngModel)]="newSystemIdL" name="'Select Available Replacement'"
                                  placeholder="{{Translate('Select Available Replacement')}}">
                        <mat-option *ngFor="let replacement of availableSystemReplacementsL"
                                    [value]="replacement.SystemId">
                          {{ replacement.SystemSerialNumber }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field *ngIf="system.Side=='Right'">
                      <mat-select (selectionChange)="selectedSystemReplacement($event,system.Side,null,null)"
                                  [(ngModel)]="newSystemIdR" name="'Select Available Replacement'"
                                  placeholder="{{Translate('Select Available Replacement')}}">
                        <mat-option *ngFor="let replacement of availableSystemReplacementsR"
                                    [value]="replacement.SystemId">
                          {{ replacement.SystemSerialNumber }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <div *ngIf="(component.ChainSysReplaceAction!=2  || component.ChainSysReplaceAction==null )&& component.SelectedActionTypeId !== 10602 && component.SelectedActionTypeId !== 17 && component.SelectedActionTypeId !== 10702 && system.SysReplaceActionId!=2 && component.ActionSelectionId == 2">
                    <mat-form-field>
                      <mat-select name="ChainSysReplaceActions" placeholder="Select Replacement" [(ngModel)]="component.ActionComponentId" required>
                        <mat-option *ngFor="let action of component.ActionsReplaceOption" [value]="action.Id">
                          {{ action.Name }}
                        </mat-option>

                      </mat-select>
                    </mat-form-field>
                  </div>

                </td>
                <td style="padding: 0px;" class="actionDetailsHeader">
                  <mat-form-field style="max-width: 110px;" *ngIf="system.SysReplaceActionId!=2 && component.ActionSelectionId == 2">
                    <mat-select placeholder="Select Brand" [(ngModel)]="component.ActionBrandId">
                      <mat-option *ngFor="let make of Makes" [value]="make.Id">
                        {{ make.Title }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </td>
                  <td style="padding: 0px;" class="actionDetailsHeader">
                    <input style="width: 100px;text-align: center;" [value]="component.ActionWorn">
                  </td>
                  <td style="padding: 0px" class="actionDetailsHeader">
                    <input style="width: 100px;text-align: center;" [value]="component.ActionBudgetLife" [(ngModel)]="component.ActionBudgetLife"
                           >
                  </td>
                  <td style="padding: 0px;" class="actionDetailsHeader" *ngIf="enableDistTravelledTracking">
                  <input style="width: 100px;text-align: center;" [value]="component.ActionBudgetDistance"
                         (focusout)="ChangesBudgetDistance(component,$event,system)" [ngClass]="{'mandatoryField': ChangeAction(component)}">
                </td>
                  <td  class="actionDetailsHeader" *ngIf="enableDistTravelledTracking" >
                   <input style="width: 100px;text-align: center;"   [value]="component.ActionDOC" 
                           (focusout)="ChangesDOC(component,$event,system)" [ngClass]="{'mandatoryField': ChangeAction(component)}" >
                  </td>
                  <td  class="actionDetailsHeader" style="padding: 0px; border-right:solid 1px">
                    
                    <input style="width: 100px;text-align: center;" [value]="component.ActionCMU" 
                           (focusout)="ChangesCMU(component,$event,system)" [ngClass]="{'mandatoryField': ChangeAction(component)}" >
                  </td>
                   
                  <td style="padding: 5px;" class="actionDetailsHeader">
                    <!-- (focusout)="ChangesBudgetDistance(component,$event,system)" -->
                    <input style="width: 100px;text-align: center;" [value]="component.PartCost"
                            [ngClass]="{'mandatoryField': OnChangeCost(component)}" (focusout)="OnChangeCost(component)" [(ngModel)]="component.PartCost">
                  </td>
                  <td style="padding: 0px;" class="actionDetailsHeader">
                    <!-- (focusout)="ChangesDOC(component,$event,system)"  -->
                    <input style="width: 100px;text-align: center;" [value]="component.MiscCost" [(ngModel)]="component.MiscCost"
                           (focusout)="OnChangeCost(component)">
                  </td>
                  <td style="padding: 0px;" class="actionDetailsHeader">
                    <!-- (focusout)="ChangesDOC(component,$event,system)"  -->
                    <input style="width: 100px;text-align: center;" [value]="component.LaborCost" [(ngModel)]="component.LaborCost"
                           (focusout)="OnChangeCost(component)">
                  </td>
                  <td style="padding: 0px;" class="actionDetailsHeader">
                    <input style="width: 100px;text-align: center;" [value]="component.ActionCost" type="number" step="0.01"
                           (focusout)="ChangesCost(component,$event,system)">
                  </td>
                  <td style="padding: 0px;" class="actionDetailsHeader">
                    <input style="width: 100px;text-align: center;" [value]="component.HoursGained" type="number" step="0.01"
                            [(ngModel)]="component.HoursGained">
                  </td>
                  <td style="padding: 0px;" class="actionDetailsHeader">
                    <input style="width: 100px;text-align: center;" [value]="component.Comment" type="text" 
                           [(ngModel)]="component.Comment">
                  </td>
                  <td *ngIf="ActiveWorkOrder==true" style="padding: 0px;" class="actionDetailsHeader">
                    <input style="width: 100px;text-align: center;" [value]="component.ActionWO" (focusout)="ChangeWorkOrder(component,$event)"> 
                  </td>
                  <td  style="padding: 0px;" class="actionDetailsHeader" *ngIf="component.StatusId!=1 && component.isForDelete">
                    <mat-icon  style="color: #f13939; cursor: pointer;"(click)="DeleteQuote(component.QuoteDetailId)">delete</mat-icon> 
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div style="text-align: end; padding-bottom: 15px; padding-right: 18px; ">
          <button mat-raised-button color="warn" *ngIf="!ShowDone && !ISEdit" (click)="onSubmit(1)">
            Save
            <i class="material-icons"></i>
          </button>
           <button mat-raised-button color="warn" *ngIf="!ShowDone && ISEdit" (click)="onSubmit(2)">
            Edit
            <i class="material-icons"></i>
          </button>
          <button mat-raised-button color="warn" *ngIf="ShowDone" (click)="GotActionSearch()">
            Done
            <i class="material-icons"></i>
          </button>
        </div>
      </mat-card>
    </mat-card>
  </div>
  